import React from 'react';
import { Truck, PackageSearch, QrCode, BadgeCheck } from 'lucide-react';

/* Same number the backend sends payment instructions from. */
const WHATSAPP_NUMBER = '601151214897';

const Footer = () => {
    return (
        <footer className="bg-[#080810] text-white border-t border-white/5">
            <div className="max-w-7xl mx-auto px-6 pt-20 pb-8">
                {/* Main grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-16">
                    {/* Brand */}
                    <div className="md:col-span-1">
                        <img src="/logo.svg" alt="DOCTAPE" className="h-10 w-auto mb-5" />
                        <p className="text-gray-400 font-light text-sm leading-relaxed">
                            Sports taping and pitchside supplies for physios, trainers and athletes.
                            Shipped free across Malaysia by TN MEDICA ENTERPRISE.
                        </p>
                    </div>

                    {/* Quick Links and Information removed */}

                    {/* Contact */}
                    <div>
                        <h4 className="text-white font-medium text-sm mb-5">Contact</h4>
                        <ul className="space-y-3">
                            <li>
                                <a href={`https://wa.me/${WHATSAPP_NUMBER}`} target="_blank" rel="noreferrer"
                                    className="flex items-center gap-2 text-gray-400 hover:text-white font-light text-sm transition-colors duration-300">
                                    <svg className="w-4 h-4 text-blue-500" fill="currentColor" viewBox="0 0 24 24">
                                        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51a12.8 12.8 0 00-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884a9.82 9.82 0 016.988 2.896 9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.465 3.488" />
                                    </svg>
                                    WhatsApp us
                                </a>
                            </li>
                            <li className="flex items-center gap-2 text-gray-500 text-xs font-light">
                                <svg className="w-4 h-4 text-blue-500/50" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                                We reply during business hours
                            </li>
                        </ul>
                    </div>
                </div>

                {/* Trust badges row */}
                <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 py-8 border-y border-white/5 mb-8">
                    {[
                        { icon: <Truck className="w-4 h-4" />, text: 'Free Delivery Nationwide' },
                        { icon: <PackageSearch className="w-4 h-4" />, text: 'Tracked Shipping' },
                        { icon: <QrCode className="w-4 h-4" />, text: 'DuitNow or Bank Transfer' },
                        { icon: <BadgeCheck className="w-4 h-4" />, text: 'SSM-Registered Business' },
                    ].map((b, i) => (
                        <div key={i} className="flex items-center gap-2 text-gray-400 text-xs font-light">
                            <span className="text-blue-500">{b.icon}</span>
                            <span>{b.text}</span>
                        </div>
                    ))}
                </div>

                {/* Bottom bar */}
                <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
                    <p className="text-gray-600 text-xs font-light">
                        &copy; {new Date().getFullYear()} TN MEDICA ENTERPRISE. All rights reserved.
                    </p>
                    <div className="flex gap-6">
                        {['Privacy Policy', 'Terms of Use', 'Cookie Policy'].map((l) => (
                            <a key={l} href="#" className="text-gray-600 hover:text-gray-400 text-xs font-light transition-colors duration-300">{l}</a>
                        ))}
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
